// Reloading the page after the customer changes which spa they are shopping at.
//
// Shared by the header's search bar (SearchBar.vue) and the standalone spa switcher
// (LocationSwitcher.vue), so the two cannot behave differently. That matters more than
// saving the duplication: both controls can be on the same page, and if either refreshed
// differently the page would come back agreeing with one of them and not the other.
//
// The cookie is already written by the time this runs, and the server reads it
// (App\Services\LocationService::bookingLocation()), so the reload needs no parameters of
// its own.

// Drops any existing ?location=, which deliberately outranks the cookie so a shared link
// shows what its sender saw - left in place it would win again and the page would come back
// showing the spa the customer just changed away from.
//
// replace() rather than assigning href, so leaving the page does not mean pressing back once
// per location the customer tried.
export function reloadForLocation() {
    const url = new URL(window.location.href);
    url.searchParams.delete('location');

    window.location.replace(url.toString());
}
